export const GotvAccountType = [
  'GOtvRes'
];